var React = require('react');

function MenuIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.5194 4.41847H0.480636C0.215938 4.41847 0 4.67756 0 5.00141C0 5.32526 0.215938 5.58434 0.480636 5.58434H10.5194C10.7841 5.58434 11 5.32245 11 5.00141C11 4.67756 10.7841 4.41847 10.5194 4.41847Z","fill":"white","key":0}),React.createElement("path",{"d":"M10.5194 0H0.480636C0.215938 0 0 0.261898 0 0.582934C0 0.903971 0.215938 1.16587 0.480636 1.16587H10.5194C10.7841 1.16587 11 0.903971 11 0.582934C11 0.261898 10.7841 0 10.5194 0Z","fill":"white","key":1}),React.createElement("path",{"d":"M7.17899 8.83695H0.480636C0.215938 8.83695 0 9.09603 0 9.41707C0 9.7381 0.215938 10 0.480636 10H7.17899C7.44369 10 7.65963 9.7381 7.65963 9.41707C7.65963 9.09603 7.44369 8.83695 7.17899 8.83695Z","fill":"white","key":2})]);
}

MenuIcon.defaultProps = {"width":"11","height":"10","viewBox":"0 0 11 10","fill":"none"};

module.exports = MenuIcon;

MenuIcon.default = MenuIcon;



//////////////////
// WEBPACK FOOTER
// /node_modules/svg-react-loader/lib/loader.js?name=MenuIcon!./components/header/assets/menu.svg
// module id = sTqI
// module chunks = 0